<template>
  <div>
    <Loader :show="loading"></Loader>
    <GamesTemplate :games="games" @go-to-game="goToGame"></GamesTemplate>
  </div>
</template>

<script>
  import _ from 'lodash';
  import Loader from '@/components/atoms/Loader';
  import GamesTemplate from '@/components/templates/GamesTemplate';

  export default {
    components: {
      GamesTemplate,
      Loader,
    },
    data() {
      return {
        games: [],
        loading: true,
      };
    },
    created() {
      this.$store
        .dispatch('fetchGames')
        .then(() => {
          this.games = _(this.$store.state.games)
            .groupBy(g => g.platform_name.toUpperCase())
            .entries()
            .map(couple => ({
              id: couple[0],
              cover: `/img/platforms/${couple[0].toUpperCase()}.png`,
              name: couple[0],
              children: _(couple[1])
                .map(g => {
                  g.name = g.title;
                  return g;
                })
                .orderBy(['name'])
                .value(),
            }))
            .orderBy(['id'])
            .value();
        })
        .then(() => (this.loading = false));
    },
    methods: {
      goToGame(id) {
        this.$router.push({ name: 'game', params: { id } });
      },
    },
  };
</script>
